import httpUtils from '@/utils/http-utils';


// User
const baseUserV2RequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_V2}/users`,
  requesterType: 'CMS_WEB_SERVICE',
};
const baseUserV1RequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_RESET_PASSWORD_API_BASE_URL_V1}/accounts`,
  requesterType: 'CMS_WEB_SERVICE',
};
const userV2ApiReqNotification = httpUtils.createRequester(baseUserV2RequesterOptions);
const userV2ApiReqErrorHandling = httpUtils.createRequester(baseUserV2RequesterOptions, 'errorHandling');
const userV1ApiReqNotification = httpUtils.createRequester(baseUserV1RequesterOptions);
const userV1ApiReqErrorHandling = httpUtils.createRequester(baseUserV1RequesterOptions, 'errorHandling');

const getUserV2Requester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return userV2ApiReqErrorHandling;
  }

  return userV2ApiReqNotification;
};
const getUserV1Requester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return userV1ApiReqErrorHandling;
  }

  return userV1ApiReqNotification;
};

const baseUserRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/users`,
  requesterType: 'CMS_WEB_SERVICE',
};
const userApiReqNotification = httpUtils.createRequester(baseUserRequesterOptions);
const userApiReqErrorHandling = httpUtils.createRequester(baseUserRequesterOptions, 'errorHandling');

const getUserRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return userApiReqErrorHandling;
  }

  return userApiReqNotification;
};

// Sales
const baseSalesRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_V2}/sales-orders`,
  requesterType: 'CRM_WEB_SERVICE',
};
const salesApiReqNotification = httpUtils.createRequester(baseSalesRequesterOptions);
const salesApiReqErrorHandling = httpUtils.createRequester(baseSalesRequesterOptions, 'errorHandling');

const getSalesRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return salesApiReqErrorHandling;
  }

  return salesApiReqNotification;
};

// Invoice
const baseInvoiceRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_INVOICE}/invoices`,
  requesterType: 'CRM_WEB_SERVICE',
};
const invoiceApiReqNotification = httpUtils.createRequester(baseInvoiceRequesterOptions);
const invoiceApiReqErrorHandling = httpUtils.createRequester(baseInvoiceRequesterOptions, 'errorHandling');

const getInvoiceRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return invoiceApiReqErrorHandling;
  }

  return invoiceApiReqNotification;
};

//User Reset Password
const baseResetPasswordRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_RESET_PASSWORD_API_BASE_URL_V1}/`,
  requesterType: 'CRM_WEB_SERVICE',
};
const resetPasswordApiReqNotification = httpUtils.createRequester(baseResetPasswordRequesterOptions);
const resetPasswordApiReqErrorHandling = httpUtils.createRequester(baseResetPasswordRequesterOptions, 'errorHandling');

const userResetPasswordRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return resetPasswordApiReqErrorHandling;
  }

  return resetPasswordApiReqNotification;
};

//Get user details
const baseGetCustomerRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_RESET_PASSWORD_API_BASE_URL_V1}/customers`,
  requesterType: 'CRM_WEB_SERVICE',
};
const getCustomerApiReqNotification = httpUtils.createRequester(baseGetCustomerRequesterOptions);
const getCustomerApiReqErrorHandling = httpUtils.createRequester(baseGetCustomerRequesterOptions, 'errorHandling');

const getCustomerDetailsRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return getCustomerApiReqErrorHandling;
  }

  return getCustomerApiReqNotification;
};

//User Update Password
const baseUpdatePasswordRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_RESET_PASSWORD_API_BASE_URL_V1}/accounts/`,
  requesterType: 'CRM_WEB_SERVICE',
};
const updatePasswordApiReqNotification = httpUtils.createRequester(baseUpdatePasswordRequesterOptions);
const updatePasswordApiReqErrorHandling = httpUtils.createRequester(baseUpdatePasswordRequesterOptions, 'errorHandling');

const userUpdatePasswordRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return updatePasswordApiReqErrorHandling;
  }

  return updatePasswordApiReqNotification;
};

class UserApi {
  authenticate(credentials, errorManagementType) {
    return userResetPasswordRequester(errorManagementType)
      .post('/accounts/authenticate', credentials)
      .then(res => res && res.data);
  }

  create(userAccountInfos, errorManagementType) {
    return getUserRequester(errorManagementType)
      .post('/', userAccountInfos)
      .then(res => res && res.data);
  }

  findById(userId, errorManagementType) {
    return getUserRequester(errorManagementType)
      .get(`/${userId}`)
      .then(res => res && res.data);
  }

  fetchUsers(role, errorManagementType) {
    return getUserV2Requester(errorManagementType)
      .get('/', {
        params: {
          role,
        },
      }).then(res => res && res.data);
  }

  listSalesOrders(customerId, year, errorManagementType) {
    return getSalesRequester(errorManagementType)
      .get('/', {
        params: {
          paging: 'no',
          customerId,
          orderBy: 'date',
          detailed: true,
          // year,
        },
      }).then(res => res && res.data);
  }

  downloadInvoice(invoiceId, filename, errorManagementType) {
    return getInvoiceRequester(errorManagementType)
      .get(`/${invoiceId}/report`, {
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}.pdf`); // or any other extension
        document.body.appendChild(link);
        link.click();
      });
    // https://api-admin.boires.ca/API/invoices/1035/report
  }

  updateUser(userId, userData, errorManagementType) {
    return getUserRequester(errorManagementType)
      .put(`/${userId}`, userData)
      .then(res => res && res.data);
  }
  updateUserPassword(userId, userData, errorManagementType) {
    return userUpdatePasswordRequester(errorManagementType)
      .put(`/${userId}/password`, userData)
      .then(res => res && res.data);
  }
  resetUserPassword2(userId, userData, errorManagementType) {
    return getUserV1Requester(errorManagementType)
      .put(`/${userId}/password`, userData)
      .then(res => res && res.data);
  }
  resetUserPassword(userData, errorManagementType) {
    return userResetPasswordRequester(errorManagementType)
      .put(`accounts/password`, userData)
      .then(res => res && res.data);
  }

  getUserDetails(customerId, userData, errorManagementType) {
    return getUserV1Requester(errorManagementType)
      .get(`/${customerId}`, userData)
      .then(res => res && res.data);
  }
  getCustomerDetails(customerId, userData, errorManagementType) {
    return getCustomerDetailsRequester(errorManagementType)
      .get(`/${customerId}/`, userData)
      .then((res) => {
       return res.data
      });
      
  }
  updateCustomerDetails(customerId, userData, errorManagementType) {
    return getCustomerDetailsRequester(errorManagementType)
      .put(`/${customerId}`, userData)
      .then(res => res && res.data);
  }
}

export default new UserApi();
